export default "__VITE_ASSET__5S3kkNwX__"